var info = {
  name: "Will Feldman",
  email: "will@willfeldman.com",
  eduEmail: "feldman.jo@northeastern.edu",
  gitHub: "https://github.com/willfeldman",
  website: "https://willfeldman.com",
  resume: "https://drive.google.com/file/d/1WXwhLj-WMyd3fSoN8z3BPParTCEd4t2A/view",
  linkedIn: "https://www.linkedin.com/in/feldmanwill/"
};

module.exports = { info };
